import { Query } from '../../_base/actionBus/Query';

export class GetUnitCVUNumber extends Query<string> {}
